import { RegisterModule } from '@/typings/common'
import {
  PublicationStorageState,
  PublicationStorageGetters,
  PublicationStorageMutations,
  PublicationStorageActions,
} from './store'
import { createMapper, registerModule as vuexRegisterModule, Module } from 'vuex-smart-module'
import { MODULE_NAME } from '../utils'


const storeModule = (
  new Module({
    namespaced: true,
    state: PublicationStorageState,
    getters: PublicationStorageGetters,
    mutations: PublicationStorageMutations,
    actions: PublicationStorageActions,
  })
)

const mapper = createMapper(storeModule)

export {
  storeModule as publicationStorageStoreModule,
  mapper as publicationStorageMapper,
}

export const registerModule: RegisterModule = ({ store }): void => {
  if (registerModule.installed) return

  vuexRegisterModule(
    store,
    MODULE_NAME,
    MODULE_NAME,
    storeModule,
  )

  registerModule.installed = true
}
